module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d11-7ee46816db5f9a83ae1dc78260be5a7a.jpg";